var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoOrders(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2618",
    "data-name": "Rectangle 2618",
    width: 52,
    height: 45.754,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6032",
    "data-name": "Group 6032",
    transform: "translate(-1041 -304)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_321",
    "data-name": "Ellipse 321",
    cx: 59,
    cy: 59,
    r: 59,
    transform: "translate(1041 304)",
    fill: "#f1f6ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6038",
    "data-name": "Group 6038",
    transform: "translate(1074 345.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6037",
    "data-name": "Group 6037",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7162",
    "data-name": "Path 7162",
    d: "M45.892,25.5V11.128L51.742,2.37A1.524,1.524,0,0,0,50.475,0H32.187a1.523,1.523,0,0,0-1.261.669L26,7.942,21.074.669A1.523,1.523,0,0,0,19.813,0H1.525A1.525,1.525,0,0,0,.259,2.37L6.1,11.113l0,23.926a1.524,1.524,0,0,0,1.523,1.524H30.672A10.663,10.663,0,1,0,45.892,25.5m-4.659-1.073a10.68,10.68,0,0,0-10.547,9.09H27.518V12.187H42.846v12.36a10.7,10.7,0,0,0-1.612-.122M33,3.047h14.63l-4.07,6.094H28.868ZM19,3.047l4.127,6.094H8.444L4.375,3.047ZM9.144,12.187H24.472V33.516H9.14ZM41.233,42.707A7.617,7.617,0,1,1,48.85,35.09a7.626,7.626,0,0,1-7.617,7.617",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7163",
    "data-name": "Path 7163",
    d: "M375.52,304.367a3.862,3.862,0,0,0-6.232,0,6.543,6.543,0,0,0,0,6.22,3.863,3.863,0,0,0,6.229,0,6.544,6.544,0,0,0,0-6.216m-3.956,1.513a.919.919,0,0,1,1.666,0,4.806,4.806,0,0,1,0,3.188.919.919,0,0,1-1.662.009,5.015,5.015,0,0,1,0-3.2",
    transform: "translate(-331.076 -272.034)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7164",
    "data-name": "Path 7164",
    d: "M127.731,270h-6.2a1.523,1.523,0,0,0,0,3.047h6.2a1.523,1.523,0,0,0,0-3.047",
    transform: "translate(-107.822 -242.578)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7165",
    "data-name": "Path 7165",
    d: "M122.583,213.047h6.091a1.523,1.523,0,0,0,0-3.047h-6.091a1.523,1.523,0,0,0,0,3.047Z",
    transform: "translate(-108.765 -188.672)",
    fill: "#0a64f9"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOrders);
export default __webpack_public_path__ + "static/media/NoOrders.d0e1a8a62968a29164112d816a766ac9.svg";
export { ForwardRef as ReactComponent };